import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, type SerializedStyles } from '@emotion/react';

import { transition } from '../styles';

export const actionsBarClassName = 'media-card-actions-bar';

export const fixedActionBarStyles = `opacity: 1;`;

export const wrapperStyles: {
    (isFixed?: boolean): SerializedStyles;
    displayName: string;
} = (isFixed?: boolean): SerializedStyles =>
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	css(isFixed ? fixedActionBarStyles : 'opacity: 0;', transition(), {
		position: 'absolute',
		top: 0,
		right: 0,
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'right',
		padding: token('space.100'),
		gap: token('space.100'),
	});

wrapperStyles.displayName = 'ActionsBarWrapper';
